import mapboxgl from '!mapbox-gl';
import $ from 'jquery';
import GLightbox from 'glightbox';

import { $Elements, BrowserEvents, Classes, TransitionDurations } from '../global/constants';
import { wait } from '../global/helpers';

export let mapInitialized = false;
export let mapMarkers = [];

mapboxgl.accessToken = 'pk.eyJ1IjoidGNoZXJjaGV1c2UiLCJhIjoiY2ozZXdscm5iMDAwMDMyczMxYmM1bTA1YyJ9.v_wmQ9N9_jqc1WttgC4qsA';

export const map = (document.getElementById('main-map')) ? new mapboxgl.Map({
	container: 'main-map',
	zoom: 2,
	center: [-45, 45],
	pitch: 0,
	bearing: 0,
	antialias: true,
	interactive: true,
	style: 'mapbox://styles/tchercheuse/ckwowscfp1a6914o971spq53x',
	attributionControl: false
}) : null;

if(map) {

	map.on('load', () => {

		map.addSource('mapbox-dem', {
			'type': 'raster-dem',
			'url': 'mapbox://mapbox.mapbox-terrain-dem-v1',
			'tileSize': 512,
			'maxzoom': 14
		});

		map.addLayer({
			'id': 'sky',
			'type': 'sky',
			'paint': {
				'sky-type': 'atmosphere',
				'sky-atmosphere-sun': [0.0, 90.0],
				'sky-atmosphere-sun-intensity': 15
			}
		});

		map.setStyle({ ...map.getStyle(), 'transition': { duration: TransitionDurations.default, delay: 0 } })

		mapInitialized = true;
		$Elements.document.trigger('map.initialized');
	});


	$Elements.document.on(BrowserEvents.page.enter, () => {

		$('.recenter-map').click(() => {
			if(!map.isMoving()) {
				map.easeTo({ bearing: 0, duration: TransitionDurations.page * 1.5 });
			}
		});

		$('.toggle-3d').click(() => {
			if(!map.isMoving()) {
				map.easeTo({ pitch: (map.getPitch()) ? 0 : 60, duration: TransitionDurations.page * 1.5 });
			}
		});
	});

	map.on('moveend', () => $('.side-buttons, .clouds').addClass(Classes.active));
}

export const defaultParcellaireColor = 'rgba(155, 91, 91, 1)';
export const parcellairesColors = (typeof parcellaires_colors !== 'undefined') ? ['match', ['get', 'cepage'], ...parcellaires_colors, defaultParcellaireColor] : defaultParcellaireColor;

export function getPageData() {

	const data = document.querySelector('.page-data');

	if(data) {
		return JSON.parse(data.dataset.data);
	}

	return null;
}

export async function clearMarkers() {
	$('.mapboxgl-marker').removeClass(Classes.active);
	await wait(TransitionDurations.default);
	mapMarkers.forEach(marker => marker.remove());
	mapMarkers = [];
}

export function changeExaggeration(exaggeration = 1) {
	map.setTerrain({ 'source': 'mapbox-dem', 'exaggeration': exaggeration });
}

export function easeTo(location) {

	return new Promise((resolve, reject) => {
		map.once('moveend', () => resolve(true));
		map.easeTo({ ...location, essential: true });
	});
}

export function flyTo(location) {
	return new Promise((resolve, reject) => {
		map.once('moveend', () => resolve(true));
		map.flyTo({ ...location, essential: true });
	});
}

export function initLightboxes() {

	$('[target="lightbox"]').each(function() {

		const id = 'lightbox-' + Date.now();
		$(this).addClass(id);

		GLightbox({
			selector: '.' + id,
			openEffect: 'fade',
			closeEffect: 'fade',
			width: 'auto',
			height: 'auto',
			videosWidth: 1280,
			skin: 'fullscreen',
		});
	});

	$('[target^="lightbox-gallery"]').each(function() {

		GLightbox({
			selector: '[target="' + this.attributes.target.value + '"]',
			openEffect: 'fade',
			closeEffect: 'fade',
			width: 'auto',
			height: 'auto',
			videosWidth: 1280,
			skin: 'fullscreen',
		});
	});
}
